import { Tag, Select } from 'antd';
import { BoxArrowInRight, Check2, XLg, ArrowClockwise, ChatLeftDots } from 'react-bootstrap-icons';
import { format } from 'date-fns';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Data from '../../data/Data';

function ProjectList({
    projects,
    user,
}) {
    const [projectFilter, setProjectFilter] = useState('inbox');
    const navigate = useNavigate();

    const userType = Data.getUserType();

    useEffect(() => {
      clearStorage();
    }, []);

    function clearStorage() {
        localStorage.removeItem('detailsMode');
        localStorage.removeItem('project');
    }
    
    function getStatusColor(status) {
        switch (status) {
            case 'accepted':
            case 'completed':
                return 'green';
            case 'in_progress':
            case 'awaiting':
                return 'orange';
            case 'declined':
                return 'red';
            default:
                return '';
        }
    }

    function getProjectStatusIcon(status) {
        switch (status) {
            case 'accepted':
            case 'completed':
                return <Check2 />;
            case 'in_progress':
            case 'awaiting':
                return <ArrowClockwise />;
            case 'declined':
                return <XLg />;
            default:
                return '';
        }
    }

    function getProjectLengthWeeks(project) {
        const deliveryDeadline = new Date(project.deliveryDeadline);
        const createdAt = new Date(project.createdAt);

        const projectLength = Math.ceil((deliveryDeadline - createdAt) / (7 * 24 * 60 * 60 * 1000));
        return projectLength + ' week' + (projectLength !== 1 ? 's' : '');
    }

    const handleChangeProjectFilter = (value) => {
        setProjectFilter(value);
    }

    function getProjectsGroupByArchived() {
        return Array.isArray(projects) ? projects.filter(project => projectFilter === 'inbox' ?
            (userType === 'customer' ? !project.archivedForCustomer : !project.archivedForDesigner) :
            (userType === 'customer' ? project.archivedForCustomer : project.archivedForDesigner)) : [];
    }

    async function handleNavigateDetails(project) {
        if (project !== null)
            localStorage.setItem('detailsMode', 'details');
        
        localStorage.setItem('project', project !== null ? JSON.stringify(project) : JSON.stringify({
            designers: [],
            deliveryDeadline: '',
            allowProposals: false,
            budget: 0,
            items: []
        }));
        navigate('/project-details');
    };

    return (
        <div className="ProjectList">
            <div>
                <div className='row pe-2 mb-3'>
                    <div className='col-6'>
                        <Select
                            defaultValue="inbox"
                            style={{ width: 200 }}
                            onChange={handleChangeProjectFilter}
                            options={[
                                { value: 'inbox', label: 'Inbox' },
                                { value: 'archived', label: 'Archived' },
                            ]}
                        />
                    </div>
                    <div className='col-6 text-end'>
                        {user && userType === 'customer' &&
                            <button className='btn btn-primary btn-sm' onClick={() => handleNavigateDetails(null)}>Create</button>
                        }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <div className='row table-header text-secondary pt-4 mb-2'>
                            <div className='col-4 col-md-4'>Name</div>
                            <div className='col-4 col-md-3'>Deadline</div>
                            <div className='d-none d-md-flex col-2'>Length</div>
                            <div className='col-1 col-md-1'>Status</div>
                            <div className='col-2 col-md-2'></div>
                        </div>
                    </div>
                    <div className='col-12'>
                        {projects && getProjectsGroupByArchived().length > 0 ?
                            getProjectsGroupByArchived().map(project => (
                                <div key={project.id} className='row mb-3 element px-2'>
                                    <div className='col-4 col-md-4 d-flex align-items-center'>{project.title}</div>
                                    <div className='col-4 col-md-3 d-flex align-items-center'>{format(project.deliveryDeadline, "yyyy.MM.dd")}</div>
                                    <div className='d-none d-md-flex col-2 d-flex align-items-center'>{getProjectLengthWeeks(project)}</div>
                                    <div className='col-3 col-md-1 d-flex align-items-center'>
                                        <Tag color={getStatusColor(project.status)}>
                                            <div className='d-none d-md-flex'>{project.status === 'in_progress' ? 'In progress' : project.status[0].toUpperCase(1) + project.status.substring(1)}</div>
                                            <div className='d-md-none'>{getProjectStatusIcon(project.status)}</div>
                                        </Tag>
                                    </div>
                                    <div className='col-1 col-md-2 py-2 d-flex justify-content-end align-items-center'>
                                        <button className='btn btn-primary btn-sm me-2' onClick={() => navigate(`/project-chat/${project.id}`)}>
                                            <div className='d-none d-lg-flex'>Chat</div>
                                            <ChatLeftDots className='d-lg-none' />
                                        </button>
                                        <button className='btn btn-primary btn-sm' onClick={() => handleNavigateDetails(project)}>
                                            <div className='d-none d-lg-flex'>Details</div>
                                            <BoxArrowInRight className='d-lg-none' style={{ transform: 'translate(-1.5px, -1px)' }} />
                                        </button>
                                    </div>
                                </div>
                            )) : (
                                <div>There are no projects in {projectFilter} list</div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProjectList;